(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('KeyTrackingService', KeyTrackingService)

    function KeyTrackingService(lodash) {
        var keys = [];
        var newTabKeyCodeCombination = [
            91, // mac command left
            93, // mac command right
            17, // ctrl
        ];

        document.addEventListener('keydown', function (event) {
            var keyCode = event.keyCode;

            keys = keys.concat(keyCode);
            keys = lodash.uniq(keys);
        });

        document.addEventListener('keyup', function (event) {
            var keyCode = event.keyCode;

            keys = lodash.pull(keys, keyCode);
        });

        function get() {
            return keys;
        }

        function has(keyCodes) {
            return lodash.intersection(keys, lodash.isArray(keyCodes) ? keyCodes : [keyCodes]).length;
        }

        function hasNewTabCombinationKeyCode() {
            return lodash.intersection(keys, newTabKeyCodeCombination).length;
        }

        return {
            get: get,
            has: has,
            hasNewTabCombinationKeyCode: hasNewTabCombinationKeyCode,
        };
    }
})();